import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { Reveal, staggerContainer, staggerItem } from "../site/Reveal";
import { TESTIMONIALS, RECOGNITION } from "@/data/content";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="bg-aero-deep">
      <div className="mx-auto max-w-[1400px] px-5 py-20 sm:px-8 sm:py-28">
        <div className="mb-14 max-w-2xl">
          <span className="font-heading text-xs uppercase tracking-[0.28em] text-saffron">
            Recognition & Trust
          </span>
          <h2 className="mt-4 font-heading text-4xl font-bold tracking-tight text-ink sm:text-5xl">
            Decades on, they still fly Sharma.
          </h2>
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid gap-5 md:grid-cols-3"
        >
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={i}
              variants={staggerItem}
              data-testid={`testimonial-${i}`}
              className="flex h-full flex-col rounded-xl border border-steel/20 bg-aero-surface p-8"
            >
              <Quote className="h-7 w-7 text-saffron/70" />
              <p className="mt-5 flex-1 font-body text-base leading-relaxed text-ink">
                "{t.quote}"
              </p>
              <footer className="mt-6 border-t border-steel/20 pt-5">
                <p className="font-heading text-sm font-semibold text-ink">
                  {t.author}
                </p>
                <p className="font-body text-xs text-steel">{t.meta}</p>
              </footer>
            </motion.blockquote>
          ))}
        </motion.div>

        <Reveal delay={0.1}>
          <div className="mt-8 grid gap-px overflow-hidden rounded-xl border border-steel/20 bg-steel/20 sm:grid-cols-3">
            {RECOGNITION.map((r, i) => (
              <div
                key={i}
                data-testid={`recognition-${i}`}
                className="flex items-center gap-4 bg-aero-surface p-6"
              >
                {i === 0 && <Star className="h-6 w-6 fill-saffron text-saffron" />}
                <div>
                  <p className="font-heading text-2xl font-black text-ink">
                    {r.value}
                  </p>
                  <p className="font-body text-xs text-steel">
                    {r.label} · {r.note}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
